import { Injectable } from '@angular/core';
import { CardDisplayType } from 'src/app/core/types';
import { UserSettingsService } from 'src/app/core/services/user-settings/user-settings.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

export const DEFAULT_CARD_DISPLAY_TYPE: CardDisplayType = 'doppeldeutsch';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class CardDisplayTypeService {
  /**
   * CardDisplayTypeService constructor.
   */
  constructor(private userSettingsService: UserSettingsService) {
    this.userSettingsService.settings$
      .pipe(untilDestroyed(this))
      .subscribe((settings) => {
        console.log('CardDisplayType updated to ' + settings.cardDisplayType);
        CardDisplayType.configuredCardDisplayType = settings.cardDisplayType;
      });
  }

  /**
   * Get the current card display type.
   * @returns {CardDisplayType} The current card display type.
   */
  currentCardDisplayType(): CardDisplayType {
    return CardDisplayType.configuredCardDisplayType;
  }

  /**
   * Change the card display type.
   * @param {CardDisplayType} v - The new card display type.
   * @returns {void}
   */
  async changeCardDisplayType(v: CardDisplayType): Promise<void> {
    await this.userSettingsService.updateSetting('cardDisplayType', v);
  }

  /**
   * Get all available card display types.
   * @returns {CardDisplayType[]} Array of all available card display types.
   */
  getAvailableCardTypes(): CardDisplayType[] {
    return ['doppeldeutsch', 'französisch', 'alpinetricks'];
  }
}
